import { ElementRef } from '@angular/core';
import { TableService } from '../service';
import { PARENT_TABLE } from '../table.injection-token';
import * as i0 from "@angular/core";
import * as i1 from "../service";
/**
 * based on pContextMenuRow but fully customized. Dont modify on update.
 * able to open context menu on right click as well as through an action button.
 */
export let ContextMenuRow = /*#__PURE__*/(() => {
  class ContextMenuRow {
    constructor(dt, tableService, el) {
      this.dt = dt;
      this.tableService = tableService;
      this.el = el;
      if (this.isEnabled()) {
        this.subscription = this.dt.tableService.contextMenuSource$.subscribe(data => {
          this.selected = this.dt.equals(this.data, data);
        });
      }
    }
    onContextMenu(event) {
      if (this.isEnabled()) {
        this.dt.handleContextMenu({
          originalEvent: event,
          rowData: this.data,
          rowIndex: this.index,
          atCursor: true
        });
        this.el.nativeElement.focus();
        event.preventDefault();
      }
    }
    isEnabled() {
      return this.uiContextMenuRowDisabled !== true;
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function ContextMenuRow_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContextMenuRow)(i0.ɵɵdirectiveInject(PARENT_TABLE), i0.ɵɵdirectiveInject(i1.TableService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: ContextMenuRow,
        selectors: [["", "uiContextMenuRow", ""]],
        hostAttrs: [1, "p-element"],
        hostVars: 5,
        hostBindings: function ContextMenuRow_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("contextmenu", function ContextMenuRow_contextmenu_HostBindingHandler($event) {
              return ctx.onContextMenu($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.isEnabled() ? 0 : undefined);
            i0.ɵɵclassProp("ui-contextmenu-selected", ctx.selected)("p-highlight-contextmenu", ctx.selected);
          }
        },
        inputs: {
          data: [0, "uiContextMenuRow", "data"],
          index: [0, "uiContextMenuRowIndex", "index"],
          uiContextMenuRowDisabled: "uiContextMenuRowDisabled"
        }
      });
    }
  }
  return ContextMenuRow;
})();
export let ContextMenuButton = /*#__PURE__*/(() => {
  class ContextMenuButton {
    constructor(dt, tableService, el) {
      this.dt = dt;
      this.tableService = tableService;
      this.el = el;
      if (this.isEnabled()) {
        this.subscription = this.dt.tableService.contextMenuSource$.subscribe(data => {
          this.selected = this.dt.equals(this.data, data);
        });
      }
    }
    onContextMenu(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.isEnabled()) {
        this.dt.handleContextMenu({
          originalEvent: event,
          rowData: this.data,
          rowIndex: this.index,
          atCursor: false
        });
        this.el.nativeElement.focus();
      }
    }
    isEnabled() {
      return true;
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function ContextMenuButton_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContextMenuButton)(i0.ɵɵdirectiveInject(PARENT_TABLE), i0.ɵɵdirectiveInject(i1.TableService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: ContextMenuButton,
        selectors: [["", "uiTableContextMenuButton", ""]],
        hostAttrs: [1, "p-element"],
        hostVars: 5,
        hostBindings: function ContextMenuButton_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ContextMenuButton_click_HostBindingHandler($event) {
              return ctx.onContextMenu($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.isEnabled() ? 0 : undefined);
            i0.ɵɵclassProp("ui-contextmenu-selected", ctx.selected)("p-highlight-contextmenu", ctx.selected);
          }
        },
        inputs: {
          data: [0, "uiTableContextMenuButton", "data"],
          index: [0, "uiTableContextMenuIndex", "index"]
        }
      });
    }
  }
  return ContextMenuButton;
})();